<script>
	import { Route, Router } from 'svelte-routing';
	import './app.css';
	import AppLayout from './lib/layouts/AppLayout.svelte';
	import Cart from './routes/Cart.svelte';
	import Checkout from './routes/Checkout.svelte';
	import Contact from './routes/Contact.svelte';
	import Home from './routes/Home.svelte';
	import Login from './routes/Login.svelte';
	import OrderDetails from './routes/OrderDetails.svelte';
	import OrdersList from './routes/OrdersList.svelte';
	import ProductDetails from './routes/ProductDetails.svelte';
	import Products from './routes/Products.svelte';
	import Signup from './routes/Signup.svelte';
	import Video from './routes/Video.svelte';
	export let url = '';
</script>

<Router {url}>
	<Route path="">
		<AppLayout>
			<Home />
		</AppLayout>
	</Route>
	<Route path="/products">
		<AppLayout>
			<Products />
		</AppLayout>
	</Route>
	<Route path="/login">
		<AppLayout>
			<Login />
		</AppLayout>
	</Route>
	<Route path="/signup">
		<AppLayout>
			<Signup />
		</AppLayout>
	</Route>
	<Route path="/cart">
		<AppLayout>
			<Cart />
		</AppLayout>
	</Route>
	<Route path="/contact">
		<AppLayout>
			<Contact />
		</AppLayout>
	</Route>
	<Route path="/product-details">
		<AppLayout>
			<ProductDetails />
		</AppLayout>
	</Route>
	<Route path="/videos">
		<AppLayout>
			<Video />
		</AppLayout>
	</Route>
	<Route path="/checkout">
		<AppLayout>
			<Checkout />
		</AppLayout>
	</Route>
	<Route path="/orders-list">
		<AppLayout>
			<OrdersList />
		</AppLayout>
	</Route>
	<Route path="/order-details/:id" let:params>
		<AppLayout>
			<OrderDetails id={params?.id} />
		</AppLayout>
	</Route>
</Router>
